import { create } from 'zustand';

export interface NavBarSlice {
  open: boolean;
  mobileOpen: boolean;
  navbarToggleMobile: () => void;
  navbarCloseMobile: () => void;
  navbarClose: () => void;
  navbarToggle: () => void;
}

export const useNavbarSlice = create<NavBarSlice>()((set) => ({
  open: true,
  mobileOpen: false,
  navbarToggleMobile: () => set((state) => ({ ...state, mobileOpen: !state.mobileOpen })),
  navbarCloseMobile: () => set((state) => ({ ...state, mobileOpen: false })),
  navbarClose: () => set((state) => ({ ...state, open: false })),
  navbarToggle: () => set((state) => ({ ...state, open: !state.open })),
}));

export const selectNavbar = (store: NavBarSlice) => ({
  open: store.open,
  mobileOpen: store.mobileOpen,
});

export const selectNavbarActions = (store: NavBarSlice) => ({
  navbarToggleMobile: store.navbarToggleMobile,
  navbarCloseMobile: store.navbarCloseMobile,
  navbarClose: store.navbarClose,
  navbarToggle: store.navbarToggle,
});
